import React from 'react';

import CioSearchBar from '~/searchCio/components/CioSearchBar';
import { CioAutosuggestProvider } from '~/searchCio/hooks/useCioAutosuggest';

const BuilderSearchBar = (_props) => {
  return (
    <CioAutosuggestProvider>
      <CioSearchBar />
    </CioAutosuggestProvider>
  );
};

export default BuilderSearchBar;
